<mat-toolbar>
  <span><a [routerLink]="['/data/user']">Felhasználók kezelése</a>&nbsp;</span>
  @if (user) {
    <span> / {{user.name}}</span>
  }
  <span class="toolbar-spacer"></span>
  <button mat-raised-button color="primary" (click)="saveUser()">
    <span translate>SAVE</span>
  </button>
</mat-toolbar>
@if (user) {
  <div class="row my-3">
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label>Felhasználónév</mat-label>
        <input type="text" matInput [(ngModel)]="user.id" disabled="disabled" readonly="readonly">
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label>Név</mat-label>
        <input type="text" matInput [(ngModel)]="user.name" disabled="disabled" readonly="readonly">
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label>Email</mat-label>
        <input type="text" matInput [(ngModel)]="user.email" disabled="disabled" readonly="readonly">
      </mat-form-field>
    </div>
    <div class="col-md-3">
      <mat-form-field class="w-100">
        <mat-label>Szerepkör</mat-label>
        <mat-select [(ngModel)]="user.role_id">
          @for (role of roles; track role) {
            <mat-option [value]="role.id">
              {{role.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-12">
      <p class="m-0">Felhasználónak elérhető cégek:</p>
      @for (c of user.companies; track c) {
        <span class="badge text-bg-secondary me-1 cursor-pointer" (click)="searchText = c.name">{{c.name}}</span>
      }
    </div>
  </div>
}

<div class="row">
  <div class="col-md-12">
    <mat-form-field class="w-100">
      <mat-label translate>SEARCH</mat-label>
      <input type="text" matInput [(ngModel)]="searchText" >
      @if (searchText) {
        <button mat-icon-button color="primary" matSuffix (click)="$event.stopPropagation();searchText = null;"><mat-icon>close</mat-icon></button>
      }
    </mat-form-field>

    @for (company of companies | search: searchText; track company) {
      <div class="d-block">
        <mat-slide-toggle color="primary" [checked]="company.checked" (change)="onSlideChange(company)">{{company.name}}</mat-slide-toggle>
      </div>
    }
  </div>
</div>
